export default __webpack_public_path__ + "static/media/default.7a11929d.jpg";